module.exports = __webpack_public_path__ + "static/media/monday.e430dad9.ogg";